import React, { Component, PropTypes } from 'react';

import prefixClassNames from 'SharedComponents/prefixClassNames';
import filterProps from 'SharedComponents/filterProps';
import classNames from 'classnames';

import './OddsButton.less';
import BigNumber from 'bignumber.js';

/** Presentation Component for OMFEOddsBanner */
@prefixClassNames()
export default class OddsButton extends Component {

    static propTypes = {
        /** Function to call when an odds button is clicked; will receive the underlying odds and match objects */
        onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        oddsId: PropTypes.any,
        odds: PropTypes.any,

        style: PropTypes.any,
        className: PropTypes.string,
    }

    static defaultProps = {
        onClick: false,
    }

    constructor(props, context) {
        super(props, context);
        this.previousOdds = props && props.odds && props.odds.odds;
        this.toggleAlt = false;
        this.increased = false;
        this.decreased = false;
    }

    componentWillUpdate(nextProps){
        this.previousOdds = this.props.odds && (this.props.odds.odds !== nextProps.odds.odds && this.props.odds.odds ) || this.previousOdds;
        this.increased = this.previousOdds && this.previousOdds < nextProps.odds.odds ;
        this.decreased = this.previousOdds && this.previousOdds > nextProps.odds.odds ;
    }

    render() {
        const {
            odds,
            className,
            onClick,
            match,
            onOddsClick,
            ...restProps,
        } = this.props;

        if(this.increased || this.decreased){
            this.toggleAlt=!this.toggleAlt;
        }

        const newProps = {
            className: classNames(className, {
                OddsButton: true,

                // Increased/Decreased
                 Increased: !this.toggleAlt && this.increased,
                 Decreased: !this.toggleAlt && this.decreased,
                 Increased2: this.toggleAlt && this.increased,
                 Decreased2: this.toggleAlt && this.decreased,


                // Availability
                Available: odds && odds.isAvailable,
                NotAvailable: !(odds && odds.isAvailable),
                // Handlers
                HasOddsClickHandler: typeof onClick === 'function',
            }),
            disabled: !odds || !odds.isAvailable,

             onClick: (e) => {
                 e.stopPropagation();
                 e.nativeEvent.stopImmediatePropagation();
                 typeof this.props.onOddsClick === 'function' && this.props.onOddsClick(e, odds,match);
             },

            ...filterProps(restProps, this.constructor.propTypes),
        };

        return (
            <button {...newProps} >{odds.odds?new BigNumber(odds.odds).round(2,BigNumber.ROUND_FLOOR).toFixed(2).toString():null}</button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/SharedComponents/OddsButton/OddsButton.js